<template>
  <span class="flex gap-1 justify-content-center flex-column w-fit">
    <span class="flex gap-1 w-fit">
      <a-tooltip v-for="item in computedTags" :key="item.key">
        <template slot="title">
          <template v-if="item.breakdown">
            <div>Payroll Authorizations: {{ item.breakdown.payroll }}</div>
            <div>Disciplinary Authorizations: {{ item.breakdown.disciplinary }}</div>
          </template>
          <template v-else>{{ item.label }}: {{ item.value }}</template>
        </template>
        <span
          class="wrapper"
          :style="{
            backgroundColor: item.color,
            color: '#fff'
          }"
        >
          {{ item.value }}
        </span>
      </a-tooltip>
    </span>
  </span>
</template>

<script>
import { Tooltip } from 'ant-design-vue'
import { statusTagColors } from '@/const'

export default {
  components: {
    'a-tooltip': Tooltip
  },
  props: {
    isManyAuth: {
      type: Boolean,
      default: false
    },
    isDetailAuth: {
      type: Boolean,
      default: false
    },
    authorization: {
      type: Object,
      default: () => ({})
    },
    associate: {
      type: Object,
      default: () => ({})
    },
    historyData: {
      type: Object,
      default: null
    }
  },
  computed: {
    history() {
      return this.historyData ?? this.authorization.history ?? {}
    },
    computedTags() {
      const createTag = (key, label, color) => {
        const historyItem = this.history[key]
        const hasBreakdown = historyItem && typeof historyItem === 'object'

        return {
          label,
          key,
          value: hasBreakdown ? (historyItem.total ?? 0) : (historyItem ?? 0),
          color,
          breakdown: hasBreakdown
            ? {
                payroll: historyItem.payroll ?? 0,
                disciplinary: historyItem.disciplinary ?? 0
              }
            : null
        }
      }

      return [
        createTag('approved', 'Accepted', statusTagColors.GREEN),
        createTag('declined', 'Declined', statusTagColors.RED)
      ]
    }
  },
  methods: {
    handleTagClick(key) {
      const href = this.$router.resolve({
        name: 'project-shift-auths',
        query: {
          associates: [this.associate.id],
          auth_statuses: [key],
          auth_types: [this.authorization.type]
        }
      }).href

      window.open(href, '_blank')
    }
  }
}
</script>

<style scoped>
.wrapper {
  width: 20px;
  height: 20px;
  font-size: 12px;
  font-weight: 700;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
